import { render } from "./RadioLabelsInput.vue?vue&type=template&id=4d728e12&scoped=true"
import script from "./RadioLabelsInput.vue?vue&type=script&lang=js"
export * from "./RadioLabelsInput.vue?vue&type=script&lang=js"

import "./RadioLabelsInput.vue?vue&type=style&index=0&id=4d728e12&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d728e12"]])

export default __exports__